/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { DivisionList01Types } from './Actions';
import INITIAL_STATE from './InitialState';

export const divisionList01ResetTimestamp = (state, { currentPage, sorts, filters, pageSize }) => ({
  ...state,
  currentPage: currentPage || state.currentPage,
  sorts: sorts || state.sorts,
  filters: filters || state.filters,
  pageSize: pageSize || state.pageSize,
  timestamp: Date.now(),
  // selectedDocuments: INITIAL_STATE.selectedDocuments,
  toDivisionOptions: INITIAL_STATE.toDivisionOptions,
  toDivisionOption: INITIAL_STATE.toDivisionOption
});

export const divisionList01FetchDivisionList01Loading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const divisionList01FetchDivisionList01Success = (
  state,
  { documents, currentPage, lastPage, total, pageSize }
) => ({
  ...state,
  documents,
  currentPage,
  lastPage,
  total,
  pageSize
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [DivisionList01Types.DIVISION_LIST01_RESET_TIMESTAMP]: divisionList01ResetTimestamp,
  [DivisionList01Types.DIVISION_LIST01_FETCH_DIVISION_LIST01_LOADING]: divisionList01FetchDivisionList01Loading,
  [DivisionList01Types.DIVISION_LIST01_FETCH_DIVISION_LIST01_SUCCESS]: divisionList01FetchDivisionList01Success
});
